module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    now: " + _vm._s(_vm.five.getNextStepPlayer().name) + " "), _c('br'), _vm._v(" winner:" + _vm._s(_vm.five.winner || '-------') + "\n    "), _c('div'), _vm._v(" "), _vm._l((_vm.five.board.getBoard()), function(row, i) {
    return _c('div', {
      staticClass: "chess-row"
    }, _vm._l((row), function(chessman, j) {
      return _c('div', [_c('div', {
        class: ( _obj = {
          chessman: true,
            last: _vm.isLast(i, j)
        }, _obj['state-' + chessman.state] = true, _obj ),
        on: {
          "click": function($event) {
            _vm.five.nextStepChoseHere(i, j)
          }
        }
      })])
      var _obj;
    }))
  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.five.historyGo(-2);
      }
    }
  }, [_vm._v("悔棋")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.five.historyGo(2);
      }
    }
  }, [_vm._v("撤销悔棋")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.five.init();
      }
    }
  }, [_vm._v("初始化")]), _vm._v(" "), _c('h4', [_vm._v("History")]), _vm._v(" "), _c('ul', {
    staticClass: "history"
  }, _vm._l((_vm.five.history), function(h, i) {
    return _c('li', {
      class: {
        current: i === _vm.five.currentStep
      }
    }, [_vm._v("\n            " + _vm._s(h) + "\n        ")])
  }))], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2699955c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 31
// module chunks = 1